import { IFormRegister } from 'routes/Main/type';

import { Typography, Box } from '@mui/material';

import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const IntakeOutput = (props: Props) => {
  const { disabled, register } = props;

  const intake = [
    {
      title: '输液量',
      variable: 'patient_status_record.infusion_amount',
    },
    {
      title: '输血量',
      variable: 'patient_status_record.transfusion_amount',
    },
    { title: '其他', variable: 'patient_status_record.intake_etc' },
  ];

  const output = [
    {
      title: '尿量    ',
      variable: 'patient_status_record.urine_amount',
    },
    {
      title: '血块量',
      variable: 'patient_status_record.blood_clot_amount',
    },
    { title: '其他', variable: 'patient_status_record.output_etc' },
  ];

  return (
    <>
      <RowContainer xs={12}>
        <RowContent title="输入量" titleRatio={1} childrenRatio={11}>
          <Box display="flex" alignItems="center">
            {intake.map(({ title, variable }) => (
              <>
                <Typography fontSize="12px" sx={{ whiteSpace: 'pre' }}>
                  {title}
                </Typography>
                <MuiTextField
                  {...register(variable)}
                  sx={{ width: '15%', margin: '0px 15px' }}
                  required={false}
                  disabled={disabled}
                />
              </>
            ))}
          </Box>
        </RowContent>
        <RowContent title="输出量" titleRatio={1} childrenRatio={11}>
          <Box display="flex" alignItems="center">
            {output.map(({ title, variable }) => (
              <>
                <Typography fontSize="12px" sx={{ whiteSpace: 'pre' }}>
                  {title}
                </Typography>
                <MuiTextField
                  {...register(variable)}
                  sx={{ width: '15%', margin: '0px 15px' }}
                  required={false}
                  disabled={disabled}
                />
              </>
            ))}
          </Box>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default IntakeOutput;
